// extracted by mini-css-extract-plugin
export default {"containerLoading":"Loading_containerLoading__7Ri0o","textLoading":"Loading_textLoading__oWduu"};